import { useEffect, useRef } from "react";
import {
    animate,
    motion,
    useInView,
    useMotionValue,
    useTransform,
} from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const STATS = [
    {
        target: 47,
        label: "of Australian software buyers regret at least one purchase they've made",
    },
    {
        target: 89,
        label: "of buyers who regret a purchase also faced disruption during implementation",
    },
    {
        target: 30,
        label: "only 3 in 10 buyers describe their purchase as fully successful, disruption-free",
    },
];

function Stat({ target, label, idx }) {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, amount: 0.6 });
    const value = useMotionValue(0);
    const display = useTransform(value, (v) => `${Math.round(v)}%`);

    useEffect(() => {
        if (!inView) return;
        const controls = animate(value, target, {
            duration: 1.8,
            ease: [0.16, 1, 0.3, 1],
        });
        return () => controls.stop();
    }, [inView, target, value]);

    return (
        <div className="stat-cell" ref={ref}>
            <motion.div
                className="stat-num"
                data-testid={`stat-value-${idx + 1}`}
            >
                {display}
            </motion.div>
            <div className="stat-label">{label}</div>
        </div>
    );
}

export default function Problem() {
    return (
        <section id="problem">
            <div className="wrap">
                <motion.div
                    className="section-head"
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.8, ease: EASE }}
                >
                    <div>
                        <h2>
                            Most software purchases don't go the way
                            businesses expect
                        </h2>
                    </div>
                    <p className="section-desc">
                        Vendors are good at demos. They're less good at
                        flagging the gaps that show up after the contract is
                        signed — the missing integration, the training that
                        wasn't included, the exit clause that doesn't exist.
                    </p>
                </motion.div>

                <div className="stats-row">
                    {STATS.map((s, i) => (
                        <Stat key={i} {...s} idx={i} />
                    ))}
                </div>
            </div>
        </section>
    );
}
